import { render, staticRenderFns } from "./GeneralClinicReportPhase.vue?vue&type=template&id=6fb90640&scoped=true&"
import script from "./GeneralClinicReportPhase.vue?vue&type=script&lang=js&"
export * from "./GeneralClinicReportPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb90640",
  null
  
)

export default component.exports